export class Tags {
  id:number;
  sufijo:number;
  prefijo:string;
  qr:string;
  ordenproduccion:number;
  lote:number;
  producto:number;
  estado:number;
  fechaelaboracion:Date;
  fechavencimiento:Date;
  comentarios:string;
  packing:number;
  tipo:number;
  tag_id:number;

  constructor(id,sufijo,prefijo,qr,ordenproduccion,lote,producto,estado,fechaelaboracion,fechavencimiento,comentarios,packing,tipo,tag_id){
    this.id = id;
    this.sufijo = sufijo;
    this.prefijo = prefijo;
    this.qr = qr;
    this.ordenproduccion = ordenproduccion;
    this.lote = lote;
    this.producto = producto;
    this.estado = estado;
    this.fechaelaboracion = fechaelaboracion;
    this.fechavencimiento = fechavencimiento;
    this.comentarios = comentarios;
    this.packing = packing;
    this.tipo = tipo;
    this.tag_id = tag_id;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    return `{
      "data":{
        "type": "packing",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "suffix":"${this.sufijo}",
          "prefix":"${this.prefijo}",
          "code":"${this.qr}",
          "production_order_id":"${this.ordenproduccion}",
          "lot_id":"${this.lote}",
          "product_id":"${this.producto}",
          "tag_status_id":"${this.estado}",
          "elaboration_date":"${this.fechaelaboracion}",
          "expiration_date":"${this.fechavencimiento}",
          "comments":"${this.comentarios}",
          "box_type_id":"${this.tipo}",
          "packing_id":"${this.packing}",
          "tag_id":"${this.tag_id}"
        }
      }
    }`;
  }

/*crea un json para la union de saldo*/
  public getJsonUnionSaldo(data:any){
    return `{
      "data":{
        "type": "packing",
        "attributes": {
          "production_order_id":"${data.ordenproduccion}",
          "code":"${data.qr}",
          "lot_id":"${data.lote}",
          "product_id":"${data.producto}",
          "tag_status_id":"1",
          "expiration_date":"${data.fechavencimiento}",
          "elaboration_date":"${data.fechaelaboracion}",
          "prefix":"${data.prefijo}",
          "suffix":"${data.sufijo}",
          "box_type_id":"3",
          "residue":"${data.saldo}"
        }
      }
    }`;
  }

  /*crea un json para actualizar los tags que se unieron en union de saldo*/
    public getJsonTagsUnionSaldo(data:any[],idUnionSaldo:string){
      let coma = ',';
      let body = `{ "data":[`;
      let pos = 0;
      for(let caja of data){
        if((pos+1) === data.length){
          coma = '';
        }
        body+=`{
                 "id":"${caja.id}",
                 "tag_id":"${idUnionSaldo}"
               }${coma}`;
        pos++;
      }
      body+=`]}`;
      //console.log("BODY PETICION ACTUALIZAR TAGS: ", body);
      return body;
    }

    /*crea un json para actualizar los tags que se agregaron a una orden de salida*/
      public getJsonOrdenSalida(data:any[],order_id:string){
        let coma = ',';
        let body = `{ "data":[`;
        let pos = 0;
        for(let tag of data){
          if((pos+1) === data.length){
            coma = '';
          }
          body+=`{
                   "id":"${tag.tag_id}",
                   "order_id":"${order_id}"
                 }${coma}`;
          pos++;
        }
        body+=`]}`;
        //console.log("BODY PETICION ACTUALIZAR TAGS: ", body);
        return body;
      }

      /*crea un json para actualizar los tags que se quitaron a una orden de salida*/
        public getJsonOrdenSalidaQuitar(data:any[]){
          let coma = ',';
          let body = `{ "data":[`;
          let pos = 0;
          for(let tag of data){
            if((pos+1) === data.length){
              coma = '';
            }
            body+=`{
                     "id":"${tag.tag_id}",
                     "order_id":null
                   }${coma}`;
            pos++;
          }
          body+=`]}`;
          //console.log("BODY PETICION ACTUALIZAR TAGS: ", body);
          return body;
        }

  /*crea un Json para la union de saldo*/
  public getJsonUnion(data:any){
    /*cambiar la orden de produccion*/
    let json = `{"data":[{"type":"tag",
             "production_order_id":"1",
             "code":"${data.qr}",
             "lot_id":"${data.lote}",
             "product_id":"${data.producto}",
             "tag_status_id":"1",
             "expiration_date":"${data.fechavencimiento}",
             "elaboration_date":"${data.fechaelaboracion}",
             "prefix":"${data.prefijo}",
             "suffix":"${data.sufijo}",
             "box_type_id":"3",
             "residue":"${data.saldo}"
           }]}`;
     // let tag = '';
     // tag = `{"type":"tag",
     //         "production_order_id":"1",
     //         "code":"${data.qr}",
     //         "lot_id":"${data.lote}",
     //         "product_id":"${data.producto}",
     //         "tag_status_id":"1",
     //         "expiration_date":"${data.fechavencimiento}",
     //         "elaboration_date":"${data.fechaelaboracion}",
     //         "prefix":"${data.prefijo}",
     //         "suffix":"${data.sufijo}",
     //         "box_type_id":"3",
     //         "residue":"${data.saldo}"
     //         }`;



     return json;
  }

  /**
   * Crea el formato JSON para el envio a través de HTTP de todos los packing como un arreglo
   * @return JSON a enviar.
   */
   public getJson2(packing:any[],saldo:any[],tipo_caja:number){
     let coma =',';
     let esp = '';
     for(let i=0;i < packing.length;i++){
       if((i+1) === packing.length && saldo.length === 0){
         coma = '';
       }
       esp += `{"type":"tag",
                "production_order_id":"${packing[i].ordenproduccion}",
                "code":"${packing[i].qr}",
                "lot_id":"${packing[i].lote}",
                "product_id":"${packing[i].producto}",
                "tag_status_id":"1",
                "expiration_date":"${packing[i].fechavencimiento}",
                "elaboration_date":"${packing[i].fechaelaboracion}",
                "prefix":"${packing[i].prefijo}","suffix":"${packing[i].id}",
                "box_type_id":"${tipo_caja}",
                "residue":"${packing[i].saldo}"}${coma}`;
     }
     if(saldo.length != 0){
       esp += `{"type":"tag",
                "production_order_id":"${saldo[0].ordenproduccion}",
                "code":"${saldo[0].qr}","lot_id":"${saldo[0].lote}",
                "product_id":"${saldo[0].producto}",
                "tag_status_id":"1",
                "expiration_date":"${saldo[0].fechavencimiento}",
                "elaboration_date":"${saldo[0].fechaelaboracion}",
                "prefix":"${saldo[0].prefijo}",
                "suffix":"${saldo[0].id}",
                "box_type_id":"2",
                "residue":"${saldo[0].saldo}"}`;
     }

     return `{"data":[${esp}]}`;
   }

 /**
  * Crea el formato JSON para el envio a través de HTTP
  * @return JSON a enviar.
  */
  public getJson3(packing:any[],id:number){
    let coma =',';
    let esp = '';
    for(let i=0;i < packing.length;i++){
      if((i+1) === packing.length){
        coma = '';
      }
      esp += `{"type":"tag","tag_status_id":"2","packing_id":"${id}","prefix":"${packing[i].prefijo}"}${coma}`;
    }

    return `{"data":[${esp}]}`;
  }

  /*
  * Crea el formato JSON para el envio a través de HTTP
  * @return JSON a enviar.
  */
  public getJson4(idtag:string){
    return `{
      "data":{
        "type": "tag",
        "id": "${idtag}",
        "attributes": {
          "id":"${idtag}",
          "tag_status_id":"3"
        }
      }
    }`;
  }
  public getJson5(idtag:string){
    return `{
      "data":{
        "type": "tag",
        "id": "${idtag}",
        "attributes": {
          "id":"${idtag}",
          "tag_status_id":"4"
        }
      }
    }`;
  }
  public getJson6(idtag:string){
    return `{
      "data":{
        "type": "tag",
        "id": "${idtag}",
        "attributes": {
          "id":"${idtag}",
          "tag_status_id":"1"
        }
      }
    }`;
  }

  public getJson7(packing:any[],status){
    let coma =',';
    let esp = '';
    for(let i=0;i < packing.length;i++){
      if((i+1) === packing.length){
        coma = '';
      }
      esp += `{"type":"tag","tag_status_id":"${status}","id":"${packing[i].id}"}${coma}`;
    }

    return `{"data":[${esp}]}`;
  }

  public getJson8(packing:any[],status){
    let coma =',';
    let esp = '';
    for(let i=0;i < packing.length;i++){
      if((i+1) === packing.length){
        coma = '';
      }
      esp += `{"type":"tag","id":"${packing[i].id_tag}"}${coma}`;
    }

    return `{"data":[${esp}]}`;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Tags.ts